<template>
  <div class="identity-info">
    <div class="info-content">
      <div class="title">
        <img src="@/assets/img/profile/shouji.png" alt="">
        <span>身份信息</span>
      </div>

      <el-form ref="form" :model="userForm" label-width="80px" size="mini">
        <div class="item-box">
          <el-form-item label="身份:">
            <el-input disabled v-if="!this.$store.state.user.roleName" v-model="userForm.roleName"></el-input>
            <el-input disabled v-if="this.$store.state.user.roleName" v-model="this.$store.state.user.roleName">
            </el-input>
          </el-form-item>

          <el-form-item label="学段:">
            <el-input disabled v-if="!this.$store.state.user.learningPeriodName" v-model="userForm.learningPeriodName">
            </el-input>
            <el-input disabled v-if="this.$store.state.user.learningPeriodName"
              v-model="this.$store.state.user.learningPeriodName"></el-input>
          </el-form-item>
        </div>

        <div class="item-box">
          <el-form-item label="年级:">
            <el-input disabled v-if="!this.$store.state.user.grade" v-model="userForm.grade"></el-input>
            <el-input disabled v-if="this.$store.state.user.grade" v-model="this.$store.state.user.grade"></el-input>
          </el-form-item>

          <el-form-item label="学校:">
            <el-input disabled v-if="!this.$store.state.user.schoolName" v-model="userForm.schoolName"></el-input>
            <el-input disabled v-if="this.$store.state.user.schoolName" v-model="this.$store.state.user.schoolName">
            </el-input>
          </el-form-item>
        </div>

      </el-form>
    </div>
  </div>

</template>

<script>
import utils from "@/util/index";
export default {
  name: "IdentityInfo",

  data() {
    return {
      userForm: {
        roleName: "未设置",
        learningPeriodName: "未设置",
        grade: "未设置",
        schoolName: "未设置"
      }
    };
  },

  methods: {
    onSubmit() {}
  }
};
</script>

<style lang="less" scoped>
.identity-info {
  user-select: none;
  width: 911px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;

  .info-content {
    width: 911px;
    height: 472px;
    border: 1px solid #ccc;
    margin-bottom: 40px;
    color: rgba(51, 51, 51, 1);
    position: relative;

    .title {
      display: flex;
      align-items: center;
      position: absolute;
      top: 65px;
      left: 100px;
      z-index: 1;
      span {
        font-size: 16px;
        margin-left: 8px;
      }
    }

    .el-form {
      width: 610px;
      position: absolute;
      top: 150px;
      left: 120px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);

      .item-box {
        display: flex;
        margin-bottom: 50px;
        .el-form-item {
          flex: 1;
        }
      }
    }
  }
}
</style>